module.exports = __webpack_public_path__ + "img/edit.ef5f4e11.svg";